export const adminOrganization = (params: { organizationId: number }) => `organization:${params.organizationId}`;
